import i from './page-header-user.container';

export default i;
